module.exports = __webpack_public_path__ + "static/Certifikat-2018-ISO-3834-2-f6290fb1b5e722752dc1194c0953cc69.pdf";